import { DocumentRenderer } from '@keystone-6/document-renderer';
import { GetServerSidePropsContext } from 'next';
import React from 'react';
import Container from '../../components/container/container.component';
import Gallery from '../../components/gallery/gallery.component';
import SectionTitle from '../../components/section-title/section-title.component';
import { getGalleryBySlug } from '../../lib';
import styles from '../../styles/[gallery].module.scss';
import Page from '../../templates/page.template';
import { GalleryProps } from '../../types/gallery-props';
interface Props extends GalleryProps { }

const GalleryPage: React.FC<Props> = ({ options, menu, gallery }) => {
  return (
    <Page
      options={options}
      menu={menu}
      title={gallery.title}
      description={options.description}
    >
      <Container
        css={{ height: 'auto', minHeight: 'calc(100vh - 240px)' }}
        column={true}
      >
        <article className={styles.content}>
          <SectionTitle title={gallery.title} />
          <DocumentRenderer document={gallery.content.document} />
          <Gallery
            images={gallery.images.map((image) => ({
              id: image.image.id,
              url: image.image.url,
              title: image.alt,
              width: image.image.width,
              height: image.image.height,
            }))}
          />
        </article>
      </Container>
    </Page>
  );
};

export async function getServerSideProps(props: GetServerSidePropsContext) {
  const slug = props.params?.gallery ?? '';
  const { galleries, menu, options } = await getGalleryBySlug(slug as string);
  if (!galleries.length) {
    return {
      notFound: true,
    };
  }

  props.res.setHeader('Cache-Control', 'public, max-age=300, s-maxage=300');

  return { props: { gallery: galleries[0], menu, options } };
}

export default GalleryPage;
